const routes = [
  {
    path: "/",
    exact: true,
    component: "Home",
  },
  {
    path: "/privacy-policy",
    exact: true,
    component: "PrivacyPolicy",
  },
];

export default routes;
